module.exports = __webpack_public_path__ + "media/images/brands/brand-ru-30d81aee00e05bf6ff6bdb07befac617.jpg";